export const READ = 'read';
export const LIST = 'list';
export const CREATE = 'create';
export const UPDATE = 'update';
export const DELETE = 'delete';
export const ASSIGN = 'assign';
export const AUTHORIZE = 'authorize';
export const EDIT = 'edit';
